/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager.AddToWaitlist {

    import ServiceCategory = Meevo.Model.ServiceCategory;
    import Employee = Meevo.Model.Employee;
    import EmployeeGenderSearchEnum = Meevo.Model.EmployeeGenderSearchEnum;

    export interface IService extends Meevo.Model.Service {
        displayName: string;
        id: string;
    }

    export interface IServiceAddOn {
        catalog: string;
        languageId: number;
        shortcut: string;
        isAddressRequired: boolean;
        isEventOnly: boolean;
        price: number;
        swapFee: number;
        availableForFemale: boolean;
        availableForMale: boolean;
        doNotAllowStepTimingOverride: boolean;
        doNotAllowTips: boolean;
        isBookable: boolean;
        isAvailablePackagesOnly: boolean;
        allowBookableWalkIn: boolean;
        employeePerformsService: boolean;
        serviceDisplayName: string;
        ignoreEmployeeMinimum: boolean;
        resourceType: number;
        contentType: string;
        isStorageUpdated: boolean;
        allowBookOnline: boolean;
        homeLocationId: number;
        enableIntelliBooking: boolean;
        excludePointPromotion: boolean;
        ownedByLocationId: number;
        atLocationId: number;
        totalLocations: number;
        availableAtLocations: number;
        objectState: number;
        objectCreationType: number;
        id: Guid;
        locationId: number;
        displayName: string;
    }

    export interface IWLSelectedService extends Meevo.Model.Service {
        service: IService;
        addOns: IServiceAddOn[];
        employee: Employee;
        employeePreference: EmployeeGenderSearchEnum;
    }

    export interface IServiceCategoryList {
        categoryList: ServiceCategory[];
        currentCategory: ServiceCategory;
        serviceList: IService[];
        currentService: IService;
        selectedServices: IWLSelectedService[];
        currentAddOns: IServiceAddOn[];

        getServiceById(id: Guid): ng.IPromise<any>;

        fetchCategoryList(): ng.IPromise<any>;

        fetchServicesList(categoryId: string): ng.IPromise<any>;

        clear(): void;

        clearSelectedService(): void;

        addCurrentToSelected(employee: any, employeePreference: EmployeeGenderSearchEnum): void;

        getServiceDisplayName(id: string): string;

        deleteFromSelected(serviceId: string): void;

        hasInSelected(serviceId: string): boolean;
    }

    export class ServiceCategoryList implements IServiceCategoryList {
        _categoryList: Array<ServiceCategory>;
        _currentCategory: ServiceCategory;
        _serviceList: IService[];
        _currentService: IService;
        _currentAddOns: IServiceAddOn[];

        private _selectedServices: IWLSelectedService[];

        get selectedServices(): IWLSelectedService[] {
            return this._selectedServices;
        }

        get currentAddOns(): IServiceAddOn[] {
            return this._currentAddOns;
        }

        set currentAddOns(data: IServiceAddOn[]) {
            this._currentAddOns = data;
        }

        constructor(
            protected $q: ng.IQService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
        ) {
            this._categoryList = [];
            this._currentCategory = null;
            this._serviceList = [];
            this._currentService = null;
            this._selectedServices = [];
            this._currentAddOns = [];
        }

        getServiceById(id: Guid): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.dataService.getItem('service', id)
                .then((service: IService | any) => {
                    this.currentService = service;
                    deferred.resolve();
                })
                .catch(() => {
                    deferred.reject();
                });

            return deferred.promise;
        }

        fetchCategoryList(): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.dataService.getListPaged('serviceCategory', {
                itemsPerPage: 10000,
                criteria: {
                    'eligibleForWalkinManager': true
                }
            })
                .then(result => {
                    this.categoryList = result;
                    deferred.resolve();
                });

            return deferred.promise;
        }

        fetchServicesList(categoryId: string): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.dataService.getListPaged('service', {
                sortBy: 'displayName',
                itemsPerPage: 10000,
                criteria: {
                    serviceCategoryId: categoryId,
                    eligibleForWalkinManager: true
                }
            })
                .then((result: Array<IService> | any): void => {
                    this.serviceList = result;
                    deferred.resolve();
                });

            return deferred.promise;
        }

        clear(): void {
            this.categoryList.length = 0;
            this.serviceList.length = 0;
            this.currentCategory = null;
            this.currentService = null;
            this.currentAddOns = [];
        }

        clearSelectedService(): void {
            this._selectedServices = [];
        }

        addCurrentToSelected(employee: Employee, employeePreference: EmployeeGenderSearchEnum): void {
            this._selectedServices.push({
                service: {...this.currentService},
                addOns: [...this.currentAddOns],
                employee: {...employee},
                employeePreference
            });
        }

        deleteFromSelected(serviceId: string): void {
            const index = _.findIndex(this._selectedServices, (service) => service.service.id === serviceId);
            this._selectedServices.splice(index, 1);
        }

        hasInSelected(serviceId: string): boolean {
            return !!_.find(this._selectedServices, (service) => service.service.id === serviceId);
        }

        get categoryList(): Array<ServiceCategory> {
            return this._categoryList;
        }

        set categoryList(data: Array<ServiceCategory>) {
            this._categoryList = data;
        }

        get currentCategory(): ServiceCategory {
            return this._currentCategory;
        }

        set currentCategory(data: ServiceCategory) {
            this._currentCategory = data;
        }

        get serviceList(): Array<IService> {
            return this._serviceList;
        }

        set serviceList(data: Array<IService>) {
            this._serviceList = data;
        }

        get currentService(): IService {
            return this._currentService;
        }

        set currentService(data: IService) {
            this._currentService = data;
        }

        getServiceDisplayName(id: string): string {
            let retVal = '';
            let service = _.find(this._serviceList, (s) => {
                return s.id === id;
            });
            if (service) {
                retVal = service.displayName;
            }

            return retVal;
        }

        static factory(): Function {
            let svc = (
                $q: ng.IQService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                busyService: Meevo.Components.Busy.IBusyService
            ) => {
                return new ServiceCategoryList($q, dataService, busyService);
            };

            svc.$inject = [
                '$q',
                'meevo.components.common.DataService',
                'meevo.components.busy.BusyService'
            ];

            return svc;
        }
    }

    angular.module('meevo.plugins.walkinManager')
        .service('meevo.plugins.walkinManager.addToWaitlist.serviceCategoryListService', ServiceCategoryList.factory());

}
